import React, { useEffect, useState } from 'react'
import {
  Grid,
  Button,
  DialogTitle,
  Typography,
  Autocomplete,
  TextField,
  Tooltip,
} from '@mui/material'
import CustomList from './CustomList'
import CustomOrderableList from './CustomOrderableList'
import { applyParentChildConstraintsOnArray } from '../utils'

function GroupingSetting({
  columns,
  groupByColumns,
  setGroupByColumns,
  accumulatedColumn = [],
  setAccumulatedColumn,
  selectTotalArr,
}) {
  const selectedAccColumn = selectTotalArr
    .filter((it) => accumulatedColumn.includes(it.path))
    .map((it) => {
      return { ...it }
    })
  const [left, setLeft] = useState([])
  const [right, setRight] = useState([])
  const [checkedLeft, setCheckedLeft] = useState([])
  const [checkedRight, setCheckedRight] = useState([])

  useEffect(() => {
    let leftItems = []
    let rightItems = []
    columns.forEach((it) => {
      const itemIndex =
        groupByColumns && groupByColumns.findIndex((m) => it.path.split('__')[0] == m)
      if (itemIndex != -1) {
        rightItems.push({ ...it, sequence: itemIndex })
      } else {
        leftItems.push(it)
      }
    })

    setLeft(leftItems)
    setRight(rightItems)
  }, [columns])

  const moveToRight = () => {
    const updatedArrayIds = new Set([
      ...applyParentChildConstraintsOnArray(
        [...checkedLeft, ...right].sort((a, b) => a.sequence - b.sequence)
      ).map((it) => it.path.split('__')[0]),
    ])
    setGroupByColumns(Array.from(updatedArrayIds))
    setCheckedLeft([])
  }

  const moveToLeft = () => {
    const checkedIds = checkedRight.map((it) => +it.path.split('__')[0])
    const updatedGroupByColumns = groupByColumns.filter((it) => {
      return !(checkedIds + '').includes(it)
    })
    setGroupByColumns(updatedGroupByColumns)
    setCheckedRight([])
  }

  return (
    <>
      <DialogTitle style={{ padding: 0, marginTop: 10 }}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          style={{ padding: 0, margin: '10px 0px' }}
        >
          <Typography className="fontWeight600 fontsize16" variant="h5">
            Group By Columns
          </Typography>
          <Tooltip
            placement="top"
            title={
              <>
                {selectedAccColumn.length === 0 ? (
                  <div>No columns selected</div>
                ) : (
                  <div>
                    {selectedAccColumn.length} columns selected
                    <ul style={{ paddingLeft: 15 }}>
                      {selectedAccColumn.map((rd) => (
                        <li>{rd.name}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </>
            }
          >
            <Autocomplete
              multiple
              limitTags={1}
              options={selectTotalArr.filter((it) => !accumulatedColumn.includes(it.path))}
              sx={{ minWidth: 165, maxWidth: 300 }}
              value={selectedAccColumn}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select total field"
                  variant="outlined"
                  color="primary"
                />
              )}
              onChange={(_, value) => {
                setAccumulatedColumn(value.map((it) => it.path))
              }}
            />
          </Tooltip>
        </Grid>
      </DialogTitle>
      <Grid container gap={2} justifyContent="center" alignItems="center">
        <Grid item>
          <CustomList
            title={'Grouping columns'}
            items={left}
            checked={checkedLeft}
            setChecked={setCheckedLeft}
          />
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              color="primary"
              size="small"
              onClick={moveToRight}
              disabled={checkedLeft.length === 0}
              aria-label="move selected right"
            >
              &gt;
            </Button>
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              color="primary"
              onClick={moveToLeft}
              disabled={checkedRight.length === 0}
              aria-label="move selected left"
            >
              &lt;
            </Button>
          </Grid>
        </Grid>
        <Grid item>
          <CustomOrderableList
            title={'Columns for grouping'}
            items={right}
            checked={checkedRight}
            setChecked={setCheckedRight}
            right={right}
            setRight={setRight}
            setGroupByColumns={setGroupByColumns}
          />
        </Grid>
      </Grid>
    </>
  )
}
export default GroupingSetting
